// @flow
import React from 'react';
import WriteTemplate from 'components/write/WriteTemplate';
import WriteHeaderContainer from 'containers/write/WriteHeaderContainer';
import SubmitBoxContainer from 'containers/write/SubmitBoxContainer';
import CategoryEditModalContainer from 'containers/write/CategoryEditModalContainer';
import WriteExtraContainer from 'containers/write/WriteExtraContainer';
import DisablePanesContainer from 'containers/write/DisablePanesContainer';
import WritePanesContainer from 'containers/write/WritePanesContainer';
import { Helmet } from 'react-helmet';

const Write = () => {
  return (
    <WriteTemplate header={<WriteHeaderContainer />}>
      <Helmet>
        <title>새 컨텐츠 등록하기 | 캐시바이</title>
      </Helmet>
      <SubmitBoxContainer />
      <WriteExtraContainer />
      <WritePanesContainer />
      <DisablePanesContainer />
      <CategoryEditModalContainer />
    </WriteTemplate>
  );
};

export default Write;



// WEBPACK FOOTER //
// ./src/pages/Write.js